export enum TextAlign {
  CENTER = "center",
  LEFT = "left",
  RIGHT = "right",
  JUSTIFY = "justify",
}
export default TextAlign;
